<template>
    <div>
        <myExcelToJson @change="onUpExcel"></myExcelToJson>
        <a class="link mg-left10" @click="add">模拟回调</a>
        <a class="link mg-left10" @click="add3">保存3</a>
        <el-input type="textarea" v-model="formData.str_items"></el-input>
        <a class="link mg-left10" @click="add2">保存</a>
<!--        <div class="flex-box nopadding wrap pd-top10 pd-right10" v-if="goods.length > 0">-->
<!--            <div class="card-box bg2 round-10 width-250 mg-left10 mg-bottom10 hand click-block" style="height: 100px"-->
<!--                 v-for="(item,index) in goods" :key="item.goods_id" @click="">-->
<!--                <div class="flex-box pd-5" v-if="item.img_lnk != ''">-->
<!--                    <div class="width-80">-->
<!--                        <img class="img-80 round-5" :src="item.img_lnk">-->
<!--                    </div>-->
<!--                    <div class="flex-box-bd tleft mg-left5 over-hide">-->
<!--                        <div class="f-bd text-nowrap">{{item.goods_cname}}</div>-->
<!--                        <div class="f-red mg-top10" v-if="item.cost_amt != ''">-->
<!--                            <span class="f18 mg-right3">{{item.cost_amt * 1}}</span>元-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="flex-box col-center fillh" v-else>-->
<!--                    <div class="flex-box-bd"></div>-->
<!--                    <div class="f-bd text-nowrap">{{item.goods_cname}}</div>-->
<!--                    <div class="f-red mg-top10" v-if="item.cost_amt != ''">-->
<!--                        <span class="f18 mg-right3">{{item.cost_amt * 1}}</span>元-->
<!--                    </div>-->
<!--                    <div class="flex-box-bd"></div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div v-else>-->
<!--            <myNodata></myNodata>-->
<!--        </div>-->
    </div>
</template>

<script>
import myExcelToJson from '../components/myExcelToJson'
import myNodata from '../components/myNodata'
import request from "../utils/request_api";
export default {
    components:{
        myNodata,
        myExcelToJson
    },
    data:function(){
        return{
            formData:{
                goods_id:'1',
                items:[],
                str_items:""
            },
            goods:[]
        }
    },
    mounted: function(){
        this.getLoad();
    },
    methods:{
        onUpExcel:function(data){
            this.formData.items = data;
            this.formData.str_items = data.join("\n");
        },
        getLoad: function(){
            this.$base.showLoading();
            this.$request.sendPost("order-c-bat/before-add", {},(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.goods = data.goods;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        add: function(){
            var data = {
                out_trade_num:'B175690398710001',
                state:'1',
                otime:'1756904000',
                remark:'',
            }
            this.$base.showLoading();
            this.$request.sendPost("vendor1/charge-callback", data,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){

                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        add2: function(){
            console.log(this.formData.str_items.split("\n"));
        },
        add3: function(){
            if(this.formData.goods_id == ''){
                this.$base.alertErr('请选择商品');
                return;
            }
            if(this.formData.items.length <= 0){
                this.$base.alertErr('请导入或输入手机号码');
                return;
            }
            this.$base.showLoading();
            this.$request.sendPost("order-c-bat/add", this.formData,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.$base.alertSuccess('下单成功，批次号：' + data);
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/blank2.vue